import { Layers, Ruler, Sofa, Video, View, Wifi } from "lucide-react";
import { openExternal } from "../../utils";

/**
 * Property badges (room, m2, floor) and media buttons (video, virtual tour)
 */
export function DetailPropertyBadges({
  room,
  m2,
  floor,
  hasFiber,
  videoUrl,
  virtualTourUrl,
  isDark,
}) {
  const badgeClass = `inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border ${
    isDark ? "border-white/20 text-white/80" : "border-gray-200 text-gray-700"
  }`;

  return (
    <div className="space-y-3">
      {/* Property Badges */}
      <div className="flex flex-wrap gap-1.5">
        {room && (
          <span className={badgeClass}>
            <Sofa className="h-3 w-3" strokeWidth={1.5} />
            {room}
          </span>
        )}
        {typeof m2 === "number" && (
          <span className={badgeClass}>
            <Ruler className="h-3 w-3" strokeWidth={1.5} />
            {m2} m²
          </span>
        )}
        {floor && (
          <span className={badgeClass}>
            <Layers className="h-3 w-3" strokeWidth={1.5} />
            {floor}
          </span>
        )}
        {hasFiber && (
          <span className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-blue-500/10 text-blue-600 border border-blue-500/20">
            <Wifi className="h-3 w-3" strokeWidth={1.5} />
            Fiber
          </span>
        )}
      </div>

      {/* Video / Virtual Tour Buttons */}
      {(videoUrl || virtualTourUrl) && (
        <div className="flex gap-2">
          {videoUrl && (
            <button
              onClick={() => openExternal(videoUrl)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium ${
                isDark
                  ? "bg-white/10 text-white hover:bg-white/20"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <Video className="h-4 w-4" strokeWidth={1.5} />
              Video
            </button>
          )}
          {virtualTourUrl && (
            <button
              onClick={() => openExternal(virtualTourUrl)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium ${
                isDark
                  ? "bg-white/10 text-white hover:bg-white/20"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <View className="h-4 w-4" strokeWidth={1.5} />
              360° Tur
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default DetailPropertyBadges;
